<template>
  <div class="page-add">
    <div class="add-title">请假审核</div>
    <div class="audit_detail">
      <div class="param_item">
        <div class="required">班级名称：</div>
        <div>{{ detailForm.className }}</div>
      </div>
      <div class="param_item">
        <div class="required">学员姓名：</div>
        <div>{{ detailForm.userName }}</div>
      </div>
      <div class="param_item">
        <div class="required">单位及职务：</div>
        <div>{{ detailForm.unitPosition }}</div>
      </div>
      <div class="param_item">
        <div class="required">请假类型：</div>
        <div>{{ detailForm.leaveTypeName }}</div>
      </div>
      <div class="param_item">
        <div class="required">
          {{ detailForm.leaveType === 3 ? "退学时间" : "请假时间" }}：
        </div>
        <div>
          {{ detailForm.leaveStartTimeName }}～{{ detailForm.leaveEndTimeName }}
        </div>
      </div>
      <div class="param_item">
        <div class="required">时长（天）：</div>
        <div>{{ detailForm.duration }}</div>
      </div>
      <div class="param_item">
        <div class="required">申请事由：</div>
        <div class="desc-right">{{ detailForm.auditNotes }}</div>
      </div>
      <div class="param_item">
        <div class="required">证明材料：</div>
        <div v-if="detailForm.attachmentName">
          {{ detailForm.attachmentName }}
          <span
            :class="[isImage ? 'file_style' : 'unClick_style']"
            @click.stop="showImgPreview"
            >预览</span
          >
          <span class="file_style" @click="downloadFile">下载</span>
        </div>
        <div v-else>暂无</div>
      </div>
    </div>
    <div class="top_title">
      <span>审核进度</span>
    </div>
    <div class="block">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
        >
          {{ activity.auditUserName }}

          <div class="margin-top-10">
            {{
              activity.auditDate == null
                ? ""
                : activity.auditDate +
                  "\u3000" +
                  activity.auditScheduleName +
                  (activity.auditContent
                    ? "\u3000" + activity.auditContent
                    : "")
            }}
          </div>
          <DealAttachment
            class="margin-top-10"
            v-if="
              activity.auditAttachmentName !== undefined &&
              activity.auditAttachmentName
            "
            :isPreview="
              isImageType(
                activity.auditAttachmentName.substr(
                  activity.auditAttachmentName.lastIndexOf('.') + 1
                )
              )
            "
            :name="activity.auditAttachmentName"
            :url="JSON.parse(activity.auditAttachment)[0].url"
          />
          <div
            class="margin-top-10"
            v-if="
              (activity.auditSchedule === 7 || activity.auditSchedule === 2) &&
              activity.classPushStatusName !== undefined
            "
          >
            <span>{{
              activity.historyPushTime + "  " + activity.classPushStatusName
            }}</span>
            <span class="deal-span" @click="asyncAgain(activity.uuid)"
              >再次同步</span
            >
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>

    <div slot="footer" class="dialog-footer">
      <butn size="medium" @click="goBack" btntype title="返回"></butn>
      <butn
        v-if="isAudit"
        btntype="primary"
        size="medium"
        @click.native="openAuditForm()"
        title="审核"
        v-permission="'audit:leave:update'"
      ></butn>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="bigImgList"
    />
    <!-- 审核流程 -->
    <AuditForm
      v-if="leaveAuditDia.flag"
      :leaveAuditDia="leaveAuditDia" 
      @updateAuditDetail="getLeaveAuditDetail()" 
      :uuid="lastAuditId"
      :thisItem="detailForm"
      @closeAuditDia="closeAuditDia"
    />
  </div>
</template>

<script>
// 审核
import butn from "@/components/button/index";
import {
  auditHistoryList,
  getLeaveAuditDetail,
  auditHistoryPush,
} from "@/api/leaveAudit";
import AuditForm from "./auditForm";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import DealAttachment from "@/views/leaveAudit/dealAttachment.vue";

export default {
  name: "leaveAuditDetail",
  components: { butn, AuditForm, ElImageViewer, DealAttachment },
  data() {
    return {
      size: "small",
      isAudit: false,
      detailForm: {},
      detailId: null,
      activities: [],
      lastAuditId: null,
      showViewer: false,
      bigImgList: [],
      isImage: false,
      isKeep: false,
      leaveAuditDia: {
        flag: false
      }
    };
  },
  created() {
    this.detailId = this.$route.query.id;
    // 获取审核详情
    this.getLeaveAuditDetail();
    // 审核记录
    this.getAuditHistoryList();
  },
  methods: {
    closeAuditDia() {
      this.leaveAuditDia.flag = false;
    },
    goBack() {
      this.$router.back();
    },
    asyncAgain(uuid) {
      auditHistoryPush(uuid).then(({ code, msg }) => {
        if (code !== 0) return;
        this.$message.success(msg);
        this.getAuditHistoryList();
      });
    },
    // 获取请假审核详情
    getLeaveAuditDetail(isAuditClick = false) {
      getLeaveAuditDetail(this.detailId).then((res) => {
        if (res && res.code == 0) {
          const { auditStatus, isKeep } = res.data
          this.detailForm = res.data;
          this.isKeep = isKeep;
          this.isAudit = auditStatus === 0 || auditStatus === 4;
          // 这里是点击审核后，重新调用了一次请假审核详情，如果是审核状态，再进行弹窗
          if (isAuditClick && this.isAudit) {
            if (this.activities && this.activities.length > 0) {
              this.detailForm.auditId = this.activities[0].auditUserId;
              this.detailForm.auditName = this.activities[0].auditUserName;
              this.leaveAuditDia.flag = true;
            } else {
              this.$message.warning('没有获取到审核进度，请刷新页面后，重试');
            }
          }
          // 判断资源类型
          const attachmentName = res.data.attachmentName;
          if (attachmentName) {
            const urlIndex = attachmentName.lastIndexOf(".");
            let ext = attachmentName.substr(urlIndex + 1);
            this.isImage = this.isImageType(ext);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取审核列表
    getAuditHistoryList() {
      auditHistoryList(this.detailId).then((res) => {
        if (res && res.code == 0) {
          let dataArray = res.data;
          if (dataArray != null && dataArray.length > 0) {
            for (var i = 0; i < dataArray.length; i++) {
              if (
                i != dataArray.length - 1 ||
                (i == dataArray.length - 1 &&
                  dataArray[i].auditSchedule != null)
              ) {
                dataArray[i].icon = "el-icon-success";
                dataArray[i].color = "#3A85FF";
              }
              dataArray[i].size = "large";
            }
            this.activities = dataArray;
            this.lastAuditId = this.activities[this.activities.length - 1].uuid;
          }
        }
      });
    },
    //附件下载
    downloadFile() {
      let attachment = JSON.parse(this.detailForm.attachment);
      let a = document.createElement("a"); //创建一个<a></a>标签
      // 针对.txt文件单独处理
      if (this.detailForm.attachment.indexOf(".txt") > 0) {
        fetch(attachment[0].url)
          .then((res) => res.blob())
          .then((blob) => {
            // 将链接地址字符内容转变成blob地址
            a.href = URL.createObjectURL(blob);
            a.download = this.detailForm.attachmentName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
          });
      } else {
        a.href = attachment[0].url;
        a.download = this.detailForm.attachmentName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); // 下载完成移除元素
      }
    },
    // 审核操作
    openAuditForm() {
      this.getLeaveAuditDetail(true)
    },
    // 查看大图
    showImgPreview() {
      if (!this.isImage) {
        return;
      }
      this.showViewer = true;
      let attachment = JSON.parse(this.detailForm.attachment);
      this.bigImgList = [attachment[0].url];
    },
    // 判断文件类型：图片
    isImageType(ext) {
      return (
        ["png", "jpg", "jpeg", "gif", "svg"].indexOf(ext.toLowerCase()) !== -1
      );
    },
    closeViewer() {
      this.showViewer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
.audit_detail {
  font-size: 14px;
  color: #343c4a;
  padding: 10px 24px 52px 24px;
  .param_item {
    display: flex;
    line-height: 42px;
  }
  .required {
    width: 100px;
    text-align: right;
  }
  .desc-right {
    width: calc(100% - 100px);
  }
  .file_style {
    color: #3a85ff;
    cursor: pointer;
    margin-left: 16px;
  }
  .unClick_style {
    color: #96a1b2;
    cursor: not-allowed;
    margin-left: 16px;
  }
  div.required:before {
    content: "* ";
    color: red;
  }
}
.width_100 {
  width: 100px;
}
.top_title {
  padding: 0 16px;
  margin-bottom: 32px;
  height: 42px;
  line-height: 42px;
  background-color: #efefef;
  color: #333333;
  font-weight: bold;
  font-size: 14px;
}
.form-text-center {
  text-align: center !important;
}
.dialog-footer {
  margin-top: 24px;
  text-align: center;
}
.deal-span {
  cursor: pointer;
  color: #3a85ff;
  margin-left: 10px;
}
.margin-top-10 {
  margin-top: 10px;
}
</style>
